var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessanger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#57b7eb",
    d: "M16 51.334C8.748 46.634 4 38.828 4 30 4 15.65 16.546 4 32 4s28 11.65 28 26-12.546 26-28 26c-1.881 0-3.718-.173-5.496-.502l-9.11 3.905a1 1 0 0 1-1.394-.92v-7.149z",
    opacity: 1,
    "data-original": "#57b7eb"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9f6f9",
    d: "m12 34 15.229-13.325a1 1 0 0 1 1.427.112L38 32l14-6-15.229 13.325a1 1 0 0 1-1.427-.112L26 28z",
    opacity: 1,
    "data-original": "#f9f6f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.854 28.606 12.197 34.46a.5.5 0 0 1-.526-.836L26.9 20.298a1.499 1.499 0 0 1 2.14.169l9.106 10.927 13.657-5.854a.5.5 0 0 1 .526.836L37.1 39.702a1.499 1.499 0 0 1-2.14-.169zm23.439-.902L38.197 32.46a.5.5 0 0 1-.581-.14l-9.344-11.213a.502.502 0 0 0-.714-.056L14.707 32.296l11.096-4.756a.5.5 0 0 1 .581.14l9.344 11.213a.502.502 0 0 0 .714.056z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4891d3",
    d: "M12.508 11.342C8.446 15.855 6 21.665 6 28c0 14.35 12.546 26 28 26 7.574 0 14.449-2.798 19.492-7.342C48.355 52.366 40.631 56 32 56c-1.881 0-3.718-.173-5.496-.502l-9.11 3.905a1 1 0 0 1-1.394-.92v-7.149C8.748 46.634 4 38.828 4 30c0-7.317 3.262-13.932 8.508-18.658z",
    opacity: 1,
    "data-original": "#4891d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 51.604C8.236 46.798 3.5 38.908 3.5 30 3.5 15.385 16.261 3.5 32 3.5S60.5 15.385 60.5 30 47.739 56.5 32 56.5c-1.859 0-3.677-.166-5.438-.483l-8.971 3.845a1.501 1.501 0 0 1-2.091-1.379zm1-.27a.5.5 0 0 0-.228-.419C9.162 46.306 4.5 38.656 4.5 30 4.5 15.916 16.832 4.5 32 4.5S59.5 15.916 59.5 30 47.168 55.5 32 55.5c-1.85 0-3.657-.17-5.405-.493a.5.5 0 0 0-.288.032l-9.11 3.904a.501.501 0 0 1-.697-.46v-7.149z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessanger);
export default __webpack_public_path__ + "static/media/messanger.57fd9d696ebd2f62b8bec3c30f094928.svg";
export { ForwardRef as ReactComponent };